var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomResetClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom-reset",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_31",
    "data-name": "\\u692D\\u5706 31",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#226fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_32",
    "data-name": "\\u692D\\u5706 32",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(2 2)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1178",
    "data-name": "\\u7EC4 1178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_900",
    "data-name": "\\u77E9\\u5F62 900",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(13 14)",
    fill: "#226fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_901",
    "data-name": "\\u77E9\\u5F62 901",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(13 20)",
    fill: "#226fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomResetClick);
export default __webpack_public_path__ + "static/media/zoom-reset-click.c1466e83e90823f6ddca735b06414e8b.svg";
export { ForwardRef as ReactComponent };